import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Col, Row } from 'reactstrap';
import FormInputSimples from '../../../comum/components/FormInputSimples';
import FormSelectSimples from './../../../comum/components/FormSelectSimples';
import Card from '../../../comum/components/Card';
import SelectFiltro from '../../../comum/components/SelectFiltro';

@observer
export class FiltroRelSintetico extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {
        return(
            <div className="filtros filtro-analise-critica">
                <Card className="area-form pb-0">
                    <Row>
                        <FormInputSimples
                            titulo="CE" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.listarEntrepostagem}
                            onChange={(event) => this.controller.setCe(event.target.value) }
                        />
                        <FormInputSimples
                            titulo="DA" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.listarEntrepostagem}
                            onChange={(event) => this.controller.setDa(event.target.value) }
                        />
                        <SelectFiltro
                            titulo="Cliente" xs={12} sm={12} md={4} lg={4} xl={2}
                            itens={this.controller.listaClientes}
                            onChange={(event) => this.controller.setCliente(event)}
                            itensValor="value" itensLabel="label"
                            valor={this.controller.cliente}
                        />
                        <SelectFiltro
                            titulo="Status" xs={12} sm={12} md={4} lg={4} xl={2}
                            itens={this.controller.listaStatus}
                            onChange={(event) => this.controller.setStatus(event)}
                            itensValor="value" itensLabel="label"
                            valor={this.controller.status}
                        />
                        <Col className="col-botoes align-items-end mb-4" xl={3} lg={4} md={6} sm={12} xs={12}>
                            <Button onClick={this.controller.listarEntrepostagem} className="btn-com-bordas-primary btn-filtrar">
                                Filtrar
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/entrepostagem/relatoriosintetico/components/FiltroRelSintetico.js